import requestChangeClothes from '../changeClothes/requestChangeClothes';
import { modifyState } from '~src/state';
import $ from 'jquery';

export default function handleGarmentSelection(clothUrl, prompt) {
  // Get the color from the clicked element (this is the clicked element)
  const color = $(this).data('color') || '';

  // Store the selected garment info
  modifyState('changeClothesSelectedGarment', {
    clothUrl,
    prompt,
    color,
  });

  // Request the change with the AI Edit API
  requestChangeClothes(clothUrl, prompt, color);
}
